import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-podcast" }

import { ref, watch, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import type { PodcastType, PodcastPayloadType } from "@/common/types/podcast";

import {
  baseInput,
  baseSelect,
  baseTextarea,
  baseTextEditor,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-podcast',
  props: {
    data: {},
    isPatch: { type: Boolean }
  },
  emits: ["update:data", "salve:data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  status: "",
  title: "",
  subtitle: "",
  episode: "",
  duration: "",
  author: "",
  explicit: "",
  summary: "",
  slug: null,
  keywords: null,
  description: null,
};

const version = ref(1);

const payload = ref<PodcastPayloadType>({ ...DEFAULT_DATA });

function update(key: keyof typeof payload.value) {
  if (props.isPatch) {
    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  Object.keys(DEFAULT_DATA).forEach((key) => {
    payload.value[key] = props.data[key];
  });
}

function maskCode(data: string) {
  return data?.replaceAll(" ", "-")?.toUpperCase();
}

function maskSlug(data: string) {
  return data
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replaceAll(" ", "-")
    .toLowerCase();
}

const debouceUpdate = debounce(update, 300);

watch(
  () => props.data,
  () => {
    version.value++;
  },
  { immediate: true }
);

watchEffect(() => {
  resumeData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.title,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((payload.value.title) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_unref(debouceUpdate)('title')))
      ],
      value: payload.value.title,
      required: ""
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("podcast.labels.title")) + " * ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value"]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.subtitle,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.subtitle) = $event)),
      value: payload.value.subtitle,
      required: ""
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("podcast.labels.subtitle")) + " * ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value"]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.episode,
      "onUpdate:modelValue": [
        _cache[3] || (_cache[3] = ($event: any) => ((payload.value.episode) = $event)),
        _cache[4] || (_cache[4] = ($event: any) => (_unref(debouceUpdate)('episode')))
      ],
      value: payload.value.episode,
      required: ""
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("podcast.labels.episode")) + " * ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value"]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.slug,
      "onUpdate:modelValue": [
        _cache[5] || (_cache[5] = ($event: any) => ((payload.value.slug) = $event)),
        _cache[6] || (_cache[6] = ($event: any) => (_unref(debouceUpdate)('slug')))
      ],
      value: payload.value.slug,
      placeholder: _unref(t)('podcast.placeholders.slug'),
      mask: maskSlug
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("podcast.labels.slug")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "placeholder"]),
    _createVNode(_unref(baseTextarea), {
      modelValue: payload.value.keywords,
      "onUpdate:modelValue": [
        _cache[7] || (_cache[7] = ($event: any) => ((payload.value.keywords) = $event)),
        _cache[8] || (_cache[8] = ($event: any) => (_unref(debouceUpdate)('keywords')))
      ],
      value: payload.value.keywords
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("podcast.labels.keywords")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value"]),
    (_openBlock(), _createBlock(_unref(baseTextEditor), {
      key: version.value,
      modelValue: payload.value.description,
      "onUpdate:modelValue": [
        _cache[9] || (_cache[9] = ($event: any) => ((payload.value.description) = $event)),
        _cache[10] || (_cache[10] = ($event: any) => (_unref(debouceUpdate)('description')))
      ]
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("podcast.labels.description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]))
  ]))
}
}

})